// Campaign questions (Kaan, 5 Kasım 2026): each campaign carries 4–6 questions that say what a good event is for this
// brand, written by the model when the campaign is first matched and edited by the brand. Every listed event is judged
// on each question; the match percentage is their weighted mean ("Çok önemli" counts twice).
export const QUESTION_MAX = 8, QUESTION_MIN_TEXT = 8, QUESTION_MAX_TEXT = 160;
export const QUESTION_WEIGHTS = { high: 'Çok önemli', normal: 'Önemli' };
export const WEIGHT_VALUE = { high: 2, normal: 1 };

const clean = value => String(value ?? '').replace(/\s+/g, ' ').trim();
const slug = text => clean(text).toLocaleLowerCase('tr-TR').replace(/[^a-z0-9çğıöşü]+/g, '-').replace(/^-|-$/g, '').slice(0, 40) || 'soru';

/** Validates a question list from the brand or the model. Returns null for "not given"; throws a message on bad input. */
export function normalizeQuestions(input) {
  if (input == null) return null;
  if (!Array.isArray(input)) throw new Error('Sorular liste olmalı.');
  if (input.length > QUESTION_MAX) throw new Error(`En çok ${QUESTION_MAX} soru eklenebilir.`);
  const seen = new Set(), out = [];
  for (const [i, q] of input.entries()) {
    const text = clean(q?.text);
    if (text.length < QUESTION_MIN_TEXT) throw new Error(`${i + 1}. soru çok kısa.`);
    if (text.length > QUESTION_MAX_TEXT) throw new Error(`${i + 1}. soru en çok ${QUESTION_MAX_TEXT} karakter olabilir.`);
    const key = text.toLocaleLowerCase('tr-TR'); if (seen.has(key)) continue; seen.add(key);
    const weight = Object.hasOwn(QUESTION_WEIGHTS, q?.weight) ? q.weight : 'normal';
    let id = clean(q?.id).slice(0, 60) || slug(text); while (out.some(o => o.id === id)) id += '-2';
    out.push({ id, text, weight });
  }
  return out;
}

/** Used when the model is unavailable: the four questions the fit already asked, in the campaign's words. */
export function defaultQuestions(campaign = {}) {
  const goal = clean(String(campaign.goal || '').split(':')[0]) || 'kampanyanın hedefi';
  const audience = clean(campaign.audience), cities = clean(campaign.cities);
  return normalizeQuestions([
    { text: audience ? `Katılımcılar hedef kitlenizden mi (${audience.slice(0, 80)})?` : 'Katılımcılar markanızın ulaşmak istediği kişilerden mi?', weight: 'high' },
    { text: `Bu etkinliğe sponsor olmak "${goal.slice(0, 80)}" hedefine hizmet eder mi?`, weight: 'high' },
    { text: 'Etkinlik basında ve sosyal medyada görünürlük sağlıyor mu?', weight: 'normal' },
    { text: cities ? `Etkinlik kampanya döneminde ve tercih ettiğiniz yerde mi (${cities.slice(0, 60)})?` : 'Etkinlik kampanya döneminde mi?', weight: 'normal' },
  ]);
}

export const sameQuestions = (a, b) => JSON.stringify(a || null) === JSON.stringify(b || null);
